import React from 'react';
import './Hero.css';
import { Link, useNavigate } from 'react-router-dom';
import SocialSidebar from './SocialSidebar';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <SocialSidebar />
      <div className="container">
        <div className="hero-content1">
          <h1>Agrix Agro | Smart Agriculture for Farmers & Agribusiness in India</h1>
          <p>Empowering Small & Marginal Farmers</p>
          <Link to='/services' className="cta-button">Get Started</Link>
        </div>
      </div>
    </section>
  );
};

export default Hero; 